import classNames from 'classnames'
import { FC } from 'react'

import { TrainingCentreView } from 'partner360/components/trainingCentre/models'

import styles from './TrainingCentreBreadcrumbs.module.scss'

interface ITrainingCentreBreadcrumbsProps {
  view: TrainingCentreView
  selectedRtm: string | null
  selectedTopicTitle?: string

  canNavigateToRtms: boolean

  onBackToRtms: () => void
  onBackToTopics: () => void
}

export const TrainingCentreBreadcrumbs: FC<ITrainingCentreBreadcrumbsProps> = ({
  view,
  selectedRtm,
  selectedTopicTitle,
  canNavigateToRtms,
  onBackToRtms,
  onBackToTopics,
}) => {
  if (view === 'rtms') {
    return null
  }

  const isTopicView = view === 'topic'

  if (view === 'topics' && !canNavigateToRtms) {
    return <div className={styles.breadcrumbs}></div>
  }

  return (
    <div className={styles.breadcrumbs}>
      <button
        className={styles.backButton}
        onClick={isTopicView ? onBackToTopics : onBackToRtms}
        type="button"
      >
        <i className="kbase kbase-arrow-left" />
      </button>

      {canNavigateToRtms && selectedRtm && (
        <>
          <div className={classNames(styles.item, styles.item_clickable)} onClick={onBackToRtms}>
            {selectedRtm}
          </div>

          {isTopicView && selectedTopicTitle && (
            <>
              <span className={styles.separator}>/</span>

              <div
                className={classNames(styles.item, styles.item_clickable, styles.item_active)}
                onClick={onBackToTopics}
              >
                {selectedTopicTitle}
              </div>
            </>
          )}
        </>
      )}

      {!canNavigateToRtms && isTopicView && selectedTopicTitle && (
        <button
          className={classNames(styles.item, styles.item_clickable, styles.item_active)}
          onClick={onBackToTopics}
          type="button"
        >
          {selectedTopicTitle}
        </button>
      )}
    </div>
  )
}
